// Maximum number of attributes a user can create.
export const MAXIMUM_NFT_ATTRIBUTES_COUNT = 10;

// Maximum length of an attribute traitType or value field.
export const MAXIMUM_NFT_ATTRIBUTES_LENGTH = 30;
